import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["label", "checkbox"]
  static values = {
    allLabel: { type: String, default: "Todas" }
  }

  connect() {
    this.update()
  }

  update() {
    const selected = this.checkboxTargets.filter(c => c.checked)
    
    if (selected.length === 0) {
      this.labelTarget.textContent = this.allLabelValue
    } else if (selected.length === 1) {
      this.labelTarget.textContent = selected[0].dataset.label
    } else {
      this.labelTarget.textContent = `${selected.length} selecionadas`
    }
  }

  clear(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    
    let changed = false
    this.checkboxTargets.forEach(c => {
      if (c.checked) {
        c.checked = false
        changed = true
      }
    })
    
    this.update()
    
    if (changed && this.checkboxTargets.length > 0) {
      this.checkboxTargets[0].dispatchEvent(new Event("change", { bubbles: true }))
    }
  }
}
